import { AppKey } from '../app/AppKey';
import { ExperimentIdentifier } from '../experiments/ExperimentIdentifier';
import { AppActionTypes } from '../store/app/action-types';
import { ExperimentActionTypes } from '../store/experiments/action-types';
import { FlowActionTypes } from '../store/flow/action-types';
import { getPostAccountCreationSteps } from '../store/flow/selectors';
import { getStepConfig } from '../views/getStepConfig';
import { Step } from '../views/Step';
export const getStepCompletionActionType = stepKey => {
  const stepConfig = getStepConfig(stepKey);

  if (stepConfig && stepConfig.stepCompletedAction) {
    return stepConfig.stepCompletedAction;
  }

  return FlowActionTypes.StepCompleted;
};
export const isOutdatedStepCompletedAction = (action, currentStep) => {
  return action.type === FlowActionTypes.StepCompleted && action.stepKey !== currentStep;
};
export const shouldGoNextStep = (action, currentStep) => {
  return action.type === getStepCompletionActionType(currentStep);
};
export const shouldGoToPostAccountCreationSteps = (action, state) => {
  const postAccountCreation = getPostAccountCreationSteps(state);

  if (postAccountCreation.length && postAccountCreation[0] !== Step.MobileAppPrompt) {
    return action.type === ExperimentActionTypes.ExperimentsFetched && action.identifierPhase === ExperimentIdentifier.PortalId;
  } else {
    return action.type === AppActionTypes.UpdateKeyValue && action.key === AppKey.IsNewPortalCreated;
  }
};